interface CurveAnchor {
  readonly length: number;
  readonly value: number;
}

const smoothstep = (amount: number): number =>
  amount * amount * (3 - 2 * amount);

export const interpolateLengthCurve = (
  length: number,
  anchors: readonly CurveAnchor[],
): number => {
  const safeLength = Number.isFinite(length)
    ? length
    : (anchors[0]?.length ?? 0);
  const first = anchors[0];
  const last = anchors.at(-1);
  if (!first || !last) throw new Error("length curve requires anchors");
  if (safeLength <= first.length) return first.value;
  if (safeLength >= last.length) return last.value;
  for (let index = 1; index < anchors.length; index += 1) {
    const right = anchors[index];
    const left = anchors[index - 1];
    if (!left || !right || safeLength > right.length) continue;
    const amount =
      (safeLength - left.length) / Math.max(1, right.length - left.length);
    return left.value + (right.value - left.value) * smoothstep(amount);
  }
  return last.value;
};

const WIDTH_CURVE = [
  { length: 160, value: 14 },
  { length: 320, value: 16 },
  { length: 640, value: 19 },
  { length: 1_200, value: 22 },
  { length: 1_800, value: 24 },
] as const;

export const snakeWidthForLength = (length: number): number =>
  interpolateLengthCurve(length, WIDTH_CURVE);
